import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class InAppMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.in_app.onlineview_edit_tour_document, (data: any) => {
      mixpanel.track(event.in_app.onlineview_edit_tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.onlineview_close_edit_tour_document, (data: any) => {
      mixpanel.track(event.in_app.onlineview_close_edit_tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.onlineview_go_to_logo_setting_tour_document, (data: any) => {
      mixpanel.track(event.in_app.onlineview_go_to_logo_setting_tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.onlineview_close_logo_setting_tour_document, (data: any) => {
      mixpanel.track(event.in_app.onlineview_close_logo_setting_tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.onlineview_go_to_signature_setting, (data: any) => {
      mixpanel.track(event.in_app.onlineview_go_to_signature_setting);
    });
    AnalyticsEventBus.$on(event.in_app.onlineview_close_signature_setting_tour_document, (data: any) => {
      mixpanel.track(event.in_app.onlineview_close_signature_setting_tour_document);
    });
  }
}
